import {makeStyles} from "@material-ui/core";

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        progress: {
            margin: 2,
            color: theme.palette.primary.main
        },
        card: {
            margin: 10
        },
        lista: {
            height: 200,
            'overflow-y':'scroll'
        },
    }));
}